module.exports = __webpack_public_path__ + "img/channel.9727529c.svg";